var _classCallCheck = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _require = require('readable-stream'),
  Duplex = _require.Duplex;
var endOfStream = require('end-of-stream');
var once = require('once');
var noop = function noop() {};
var IGNORE_SUBSTREAM = {};
var ObjectMultiplex = /*#__PURE__*/function (_Duplex) {
  "use strict";

  _inherits(ObjectMultiplex, _Duplex);
  function ObjectMultiplex() {
    var _this;
    var _opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, ObjectMultiplex);
    var opts = Object.assign({}, _opts, {
      objectMode: true
    });
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ObjectMultiplex).call(this, opts));
    _this._substreams = {};
    return _this;
  }
  _createClass(ObjectMultiplex, [{
    key: "createStream",
    value: function createStream(name) {
      // validate name
      if (!name) throw new Error('ObjectMultiplex - name must not be empty');
      if (this._substreams[name]) throw new Error('ObjectMultiplex - Substream for name "${name}" already exists');

      // create substream
      var substream = new Substream({
        parent: this,
        name: name
      });
      this._substreams[name] = substream;

      // listen for parent stream to end
      anyStreamEnd(this, function (err) {
        substream.destroy(err);
      });
      return substream;
    } // ignore streams (dont display orphaned data warning)
  }, {
    key: "ignoreStream",
    value: function ignoreStream(name) {
      // validate name
      if (!name) throw new Error('ObjectMultiplex - name must not be empty');
      if (this._substreams[name]) throw new Error('ObjectMultiplex - Substream for name "${name}" already exists');
      // set
      this._substreams[name] = IGNORE_SUBSTREAM;
    } // stream plumbing
  }, {
    key: "_read",
    value: function _read() {}
  }, {
    key: "_write",
    value: function _write(chunk, encoding, callback) {
      // parse message
      var name = chunk.name;
      var data = chunk.data;
      if (!name) {
        console.warn("ObjectMultiplex - malformed chunk without name \"".concat(chunk, "\""));
        return callback();
      }

      // get corresponding substream
      var substream = this._substreams[name];
      if (!substream) {
        console.warn("ObjectMultiplex - orphaned data for stream \"".concat(name, "\""));
        return callback();
      }

      // push data into substream
      if (substream !== IGNORE_SUBSTREAM) {
        substream.push(data);
      }
      callback();
    }
  }]);
  return ObjectMultiplex;
}(Duplex);
var Substream = /*#__PURE__*/function (_Duplex2) {
  "use strict";

  _inherits(Substream, _Duplex2);
  function Substream(_ref) {
    var _this2;
    var parent = _ref.parent,
      name = _ref.name;
    _classCallCheck(this, Substream);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Substream).call(this, {
      objectMode: true
    }));
    _this2._parent = parent;
    _this2._name = name;
    return _this2;
  }
  _createClass(Substream, [{
    key: "_read",
    value: function _read() {}
  }, {
    key: "_write",
    value: function _write(chunk, enc, callback) {
      this._parent.push({
        name: this._name,
        data: chunk
      });
      callback();
    }
  }]);
  return Substream;
}(Duplex);
module.exports = ObjectMultiplex;

// util

function anyStreamEnd(stream, _cb) {
  var cb = once(_cb);
  endOfStream(stream, {
    readable: false
  }, cb);
  endOfStream(stream, {
    writable: false
  }, cb);
}